import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id D9FCEB1D-004D-442E-A979-320101768F99
 * name view-list
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-list.svg
 * tags
 * - View 
 */
export const ViewListIcon = createSvgIcon(<><path d="M9,5V9H21V5M9,19H21V15H9M9,14H21V10H9M4,9H8V5H4M4,19H8V15H4M4,14H8V10H4V14Z" /></>, 'ViewListIcon');
export default ViewListIcon